/**
 * Animation duration constants (in milliseconds)
 * Use these for consistent timing across the application
 */
export const ANIMATION_DURATION = {
  /** Fast transitions (300ms) - Quick UI feedback */
  FAST: 300,
  /** Medium transitions (650ms) - Standard animations */
  MEDIUM: 650,
  /** Slow transitions (1400ms) - Camera movements, major state changes */
  SLOW: 1400,
  /** Very slow transitions (2000ms) - Complex multi-phase animations */
  VERY_SLOW: 2000,
} as const;

/**
 * Easing functions for smooth animations
 */
export const EASING = {
  /** Linear progression (no easing) */
  LINEAR: (t: number) => t,

  /** Cubic ease-in-out - Smooth acceleration and deceleration */
  EASE_IN_OUT_CUBIC: (t: number) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2,

  /** Sine ease-in-out - Very smooth, natural motion */
  EASE_IN_OUT_SINE: (t: number) =>
    -(Math.cos(Math.PI * t) - 1) / 2,
} as const;

/**
 * Transition delays (in milliseconds)
 * Small delays to ensure DOM is ready before animations
 */
export const TRANSITION_DELAY = {
  /** Short delay (50ms) - Minimal wait */
  SHORT: 50,
  /** Medium delay (100ms) - Standard wait for DOM readiness */
  MEDIUM: 100,
  /** Long delay (200ms) - Ensure complex renders complete */
  LONG: 200,
} as const;

/**
 * Loading screen transition duration
 */
export const LOADING_SCREEN_TRANSITION_MS = 600;
